module.exports = __webpack_public_path__ + "img/it_seguroportatil.e55c139d.png";